<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true"
    class="no-field-space article-type-attribute-editor">
    <sc-dialog-title>
      {{ 'Artikel' | translate: ['erp.ui.article-editor.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <app-service-response [responseMessages]="responseMessages"></app-service-response>
    <sc-flex-fitting-content [vertical]="true">
        <sc-scroll-pane>
          <form [formGroup]="formGroup">
            <sc-padding>
                    <sc-flex [stretchContent]="true">
                        <sc-flex-fitting-content>
                            <sc-flex [vertical]="true" [stretchContent]="true">
                                <mat-form-field appearance="fill" read>
                                    <mat-label>{{ 'ID' | translate: ['erp.entity.article.id', translationService.language]}}</mat-label>
                                    <input matInput formControlName="id" [readonly]="true">
                                </mat-form-field>
                                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                                <sc-dictionary-field [model]="articleType?.name" [maxlength]="255"
                                    defaultLabel="Article Type" [disabled]="true"
                                    labelDictionaryKey="erp.entity.article.name">
                                </sc-dictionary-field>
                                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                                <mat-checkbox name="archived" formControlName="archived">
                                  {{'archived' | translate: ['erp.entity.article.archived', translationService.language]}}
                                </mat-checkbox>
                            </sc-flex>
                        </sc-flex-fitting-content>
                    </sc-flex>
                    <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
                    <sc-sub-title>
                        {{ 'Eigenschaften' | translate: ['erp.ui.article-editor.subtitle.attribute-list',
                        translationService.language]}}
                    </sc-sub-title>
                    <sc-content-spacer [vertical]="true"></sc-content-spacer>
                    <sc-flex [stretchContent]="true">
                        <ng-container [formGroup]="attributesFormGroup" *ngFor="let group of attributeGroupsArtice; let i = index">
                            <sc-content-spacer *ngIf="i>0"></sc-content-spacer>
                            <sc-flex-fitting-content>
                                <sc-bordered-tile>
                                    <sc-padding>
                                      <ng-container *ngIf="article != null">
                                        <app-dictionary-entry-label [model]="group.name"></app-dictionary-entry-label>
                                        <app-attribute-group [formGroup]="attributesFormGroup" [attributeGroup]="group" [valuesMap]="article.valuesMap" [usage]="group.usage"></app-attribute-group>
                                      </ng-container>
                                    </sc-padding>
                                </sc-bordered-tile>
                            </sc-flex-fitting-content>
                        </ng-container>
                    </sc-flex>
                <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
                <sc-sub-title>
                    {{ 'Beschreibungen' | translate: ['erp.ui.article-editor.subtitle.descriptions', translationService.language]}}
                    <sc-content-spacer [grow]="true"></sc-content-spacer>
                    <button mat-stroked-button (click)="addDescription()">
                        <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                        add
                    </button>
                </sc-sub-title>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>

                <sc-bordered-tile>
                    <sc-scroll-pane>
                        <table mat-table [dataSource]="descriptionsDataSource" matSort
                            (matSortChange)="announceSortChange($event)">

                            <ng-container matColumnDef="usage">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                    sortActionDescription="Sort by usage">
                                    {{'Usage' | translate: ['erp.ui.article-editor.table.description.usage', translationService.language]}}
                                </th>
                                <td mat-cell *matCellDef="let element"> {{element.usage}} </td>
                            </ng-container>

                            <ng-container matColumnDef="content">
                                <th mat-header-cell *matHeaderCellDef>
                                  {{'Titel / Text' | translate: ['erp.ui.article-editor.table.description.title-text', translationService.language]}}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <p><strong><app-dictionary-entry-label [model]="element.title"></app-dictionary-entry-label></strong></p>
                                    <p style="word-wrap: break-word; white-space: pre-wrap;"><app-dictionary-entry-label [model]="element.text"></app-dictionary-entry-label></p>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="commands">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button (click)="editDescription(element)"><sc-icon
                                            class="fa-light fa-pencil"></sc-icon></button>
                                    <button mat-icon-button (click)="removeDescription(element)"><sc-icon
                                            class="fa-light fa-trash"></sc-icon></button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="descriptionDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: descriptionDisplayedColumns;"></tr>
                        </table>
                    </sc-scroll-pane>
                </sc-bordered-tile>

                <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
                <sc-sub-title>
                    {{ 'Verkaufspreise' | translate: ['erp.ui.article-editor.subtitle.retailprices', translationService.language]}}
                    <sc-content-spacer [grow]="true"></sc-content-spacer>
                    <mat-checkbox name="retailPricesFromBasicArticle" formControlName="retailPricesFromBasicArticle">
                      {{'Verkaufspreise anhand Basisartikel' | translate: ['erp.ui.article-editor.action.use-retailprices-from-basicarticle', translationService.language]}}
                    </mat-checkbox>
                    <sc-content-spacer></sc-content-spacer>
                    <button mat-stroked-button (click)="addRetailPrice()" [disabled]="this.article.retailPricesFromBasicArticle === true">
                        <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                        {{'add' | translate: ['erp.ui.article-editor.action.add-retailprice', translationService.language]}}
                    </button>
                </sc-sub-title>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>

                <sc-bordered-tile>
                    <ng-container *ngIf="article.retailPricesFromBasicArticle === false" >
                      <app-retailprice-list [columns]="retailPricesDisplayedColumns"
                                          [datasource]="retailPricesDataSource"
                                          [editRetailPriceFunction]="editRetailPrice"
                                          [removeRetailPriceFunction]="removeRetailPrice"></app-retailprice-list>
                    </ng-container>
                    <ng-container *ngIf="article.retailPricesFromBasicArticle === true" >
                      <app-retailprice-basicarticle-list [columns]="retailPricesBasicArticleDisplayedColumns"
                                          [datasource]="retailPricesBasicArticleDataSource"></app-retailprice-basicarticle-list>
                    </ng-container>
                </sc-bordered-tile>

                <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
                <sc-sub-title>
                    {{ 'Einkaufspreise' | translate: ['erp.ui.article-editor.subtitle.costsprices', translationService.language]}}
                    <sc-content-spacer [grow]="true"></sc-content-spacer>
                    <button mat-stroked-button (click)="addCostsPrice()">
                        <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                        {{'add' | translate: ['erp.ui.article-editor.action.add-costsprice', translationService.language]}}
                    </button>
                </sc-sub-title>
                <sc-content-spacer [vertical]="true"></sc-content-spacer>

                <sc-bordered-tile>
                    <app-costsprice-list
                        [articleType]="articleType"
                        [hideVatPrices]="hideVatPrices"
                        [datasource]="costsPricesDataSource"
                        [editCostsPriceFunction]="editCostsPrice"
                        [removeCostsPriceFunction]="removeCostsPrice"></app-costsprice-list>
                </sc-bordered-tile>

            </sc-padding>
          </form>
        </sc-scroll-pane>
    </sc-flex-fitting-content>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.article-editor.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
          {{ 'Übernehmen' | translate: ['erp.ui.article-editor.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
